import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import {
  setCapacityPlaningCollaborator,
  setBreadCrumbs,
  setFilterCollaborators,
  setSelectedCollaboratorName,
  setCapacityPlaningCollaboratorTab
} from "Actions";

import Item from "./Item";
import NotFoundV2 from "../NotFound/NotFoundV2";

class CapacityPlaningList extends Component {
  handleRedirectCapacityCollaborator = ({ id, name, firstName, lastName }) => {
    const { dispatch } = this.props;
    let collaboratorName =
      firstName && lastName ? firstName + " " + lastName : name;
    dispatch(
      setCapacityPlaningCollaborator({
        id: id,
        name: collaboratorName
      })
    );
    dispatch(setCapacityPlaningCollaboratorTab("COLLABORATOR_SPACE"));
    dispatch(push(`/capacity-planing/collaborator/${collaboratorName}/${id}`));
  };

  handleRedirectCalendarCollaborator = ({ id, name, firstName, lastName }) => {
    const { dispatch } = this.props;
    let collaboratorName =
      firstName && lastName ? firstName + " " + lastName : name;
    dispatch(
      setCapacityPlaningCollaborator({
        id: id,
        name: collaboratorName
      })
    );
    dispatch(setCapacityPlaningCollaboratorTab("CALENDAR"));
    dispatch(push(`/capacity-planing/collaborator/${collaboratorName}/${id}`));
  };

  handleRedirectCollaboratorSetting = () => {
    const { dispatch } = this.props;
    dispatch(
      setBreadCrumbs({ url: "/capacity-planing/production", params: [] })
    );
    dispatch(push(`/collaborators-settings`));
  };

  handleRedirectCollaboratorCalendarTable = (id, name) => {
    const { dispatch } = this.props;
    dispatch(
      setFilterCollaborators([{ value: id, label: name, color: "#000000" }])
    );
    dispatch(setSelectedCollaboratorName(name));

    dispatch(push(`/calendar/${name}/${id}`));
  };

  render() {
    const { fetched, items, erpData } = this.props;

    return (
      <div className="medium-12">
        {fetched && items.length ? (
          items.map((item, i) => {
            return (
              <Item
                item={item}
                erpData={erpData}
                key={`collaborator-${item.id}`}
                handleRedirectCapacityCollaborator={
                  this.handleRedirectCapacityCollaborator
                }
                handleRedirectCollaboratorSetting={
                  this.handleRedirectCollaboratorSetting
                }
                handleRedirectCollaboratorCalendarTable={
                  this.handleRedirectCollaboratorCalendarTable
                }
                handleRedirectCalendarCollaborator={
                  this.handleRedirectCalendarCollaborator
                }
              />
            );
          })
        ) : (
          <NotFoundV2 />
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetched: state.capacityPlaning.production.fetched
});

export default connect(mapStateToProps)(CapacityPlaningList);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningList.js